import ssoHttp from "./ssoHttp";

export const EMPRESA_SSO_POR_BRAND = {
  dinar: 5,
  sack: 6,
};

export function getSsoAppName(brandOrEmpresa) {
  const normalized = String(brandOrEmpresa ?? "").toLowerCase();
  if (normalized === "sack" || Number(brandOrEmpresa) === 6) {
    return "PLANIFICADORSACK";
  }
  return "PLANIFICADOR";
}

export function getEmpresaSsoId(brand) {
  const empresa = EMPRESA_SSO_POR_BRAND[String(brand || "").toLowerCase()];
  if (!empresa) {
    throw new Error(
      `No existe empresa SSO configurada para ${
        brand || "la aplicación actual"
      }`,
    );
  }
  return empresa;
}

export const PERFILES_PLANIFICADOR = [
  { label: "Administrador", value: "ADMIN", perfilId: 19, brands: ["dinar", "sack"] },
  {
    label: "Administrador Planificador",
    value: "ADMIN_PLANIFICADOR",
    perfilId: 20,
    brands: ["dinar", "sack"],
  },
  {
    label: "Coordinador",
    value: "COORDINADOR_VENDEDOR",
    perfilId: 21,
    brands: ["dinar"],
  },
  {
    label: "Vendedor",
    value: "VENDEDOR_PLANIFICADOR",
    perfilId: 22,
    brands: ["dinar"],
  },
  {
    label: "Coordinador Mayorista",
    value: "COORDINADOR_MAYORISTA",
    perfilId: 24,
    brands: ["sack"],
  },
  {
    label: "Coordinador sin canal",
    value: "COORDINADOR_SIN_CANAL",
    perfilId: 25,
    brands: ["sack"],
  },
  {
    label: "Vendedor Retail",
    value: "VENDEDOR_RETAIL",
    perfilId: 26,
    brands: ["sack"],
  },
  {
    label: "Vendedor Mayorista",
    value: "VENDEDOR_MAYORISTA",
    perfilId: 27,
    brands: ["sack"],
  },
];

const clean = (value) =>
  value === null || value === undefined ? "" : String(value).trim();

const asArray = (value) => {
  if (Array.isArray(value)) return value.map(clean).filter(Boolean);
  return clean(value).split(",").map(clean).filter(Boolean);
};

const getPerfilId = (rol) =>
  PERFILES_PLANIFICADOR.find((item) => item.value === rol)?.perfilId;

const PERFIL_SSO_A_ROL = {
  ADMIN: "ADMIN",
  ADMINISTRADOR: "ADMIN",
  ADMIN_PLANIFICADOR: "ADMIN_PLANIFICADOR",
  "ADMINISTRADOR PLANIFICADOR": "ADMIN_PLANIFICADOR",
  COORDINADOR_VENDEDOR: "COORDINADOR_VENDEDOR",
  COORDINADOR: "COORDINADOR_VENDEDOR",
  VENDEDOR_PLANIFICADOR: "VENDEDOR_PLANIFICADOR",
  VENDEDOR: "VENDEDOR_PLANIFICADOR",
  COORDINADOR_MAYORISTA: "COORDINADOR_MAYORISTA",
  "COORDINADOR MAYORISTA": "COORDINADOR_MAYORISTA",
  COORDINADOR_SIN_CANAL: "COORDINADOR_SIN_CANAL",
  "COORDINADOR SIN CANAL": "COORDINADOR_SIN_CANAL",
  VENDEDOR_RETAIL: "VENDEDOR_RETAIL",
  "VENDEDOR RETAIL": "VENDEDOR_RETAIL",
  VENDEDOR_MAYORISTA: "VENDEDOR_MAYORISTA",
  "VENDEDOR MAYORISTA": "VENDEDOR_MAYORISTA",
};

const normalizePerfilSso = (perfil) => {
  const raw = clean(perfil);
  const key = raw.toUpperCase();
  return {
    perfil: PERFIL_SSO_A_ROL[key] || raw,
    perfilDescripcion: raw,
  };
};

export function getPerfilesPermitidos(perfilActual, brand) {
  const brandActual = clean(brand).toLowerCase();
  const perfilesEmpresa = PERFILES_PLANIFICADOR.filter((perfil) =>
    perfil.brands.includes(brandActual),
  );

  if (perfilActual === "ADMIN") return perfilesEmpresa;

  if (perfilActual === "ADMIN_PLANIFICADOR") {
    return perfilesEmpresa.filter((perfil) => perfil.value !== "ADMIN");
  }

  return [];
}

export function buildJsonPerfil(rol, data = {}) {
  const empresaId = Number(data.empresaId);
  if (!empresaId) throw new Error("Debe informar la empresa del usuario");

  const base = {
    empresaId,
    vendedorCodigo: null,
    vendedoresPermitidos: [],
    canalesPermitidos: [],
    sucursalesPermitidas: [],
    centrosPermitidos: [],
    almacenesPermitidos: [],
    organizacionesVentaPermitidas: [],
    sectoresPermitidos: [],
    listasPrecioPermitidas: [],
    historia: false,
    verTodosLosVendedores: false,
    verTodosLosCanales: false,
    verTodasLasSucursales: false,
    verTodosLosCentros: false,
    verTodosLosAlmacenes: false,
  };

  if (rol === "ADMIN" || rol === "ADMIN_PLANIFICADOR") {
    return {
      ...base,
      historia: true,
      verTodosLosVendedores: true,
      verTodosLosCanales: true,
      verTodasLasSucursales: true,
      verTodosLosCentros: true,
      verTodosLosAlmacenes: true,
    };
  }

  if (["COORDINADOR_VENDEDOR", "COORDINADOR_MAYORISTA", "COORDINADOR_SIN_CANAL"].includes(rol)) {
    return {
      ...base,
      vendedoresPermitidos: asArray(data.vendedoresPermitidos),
      canalesPermitidos:
        rol === "COORDINADOR_MAYORISTA"
          ? ["S4"]
          : asArray(data.canalesPermitidos),
      sucursalesPermitidas: asArray(data.sucursalesPermitidas),
      centrosPermitidos: asArray(data.centrosPermitidos),
      almacenesPermitidos: asArray(data.almacenesPermitidos),
      organizacionesVentaPermitidas: asArray(
        data.organizacionesVentaPermitidas,
      ),
      sectoresPermitidos: asArray(data.sectoresPermitidos),
      listasPrecioPermitidas: asArray(data.listasPrecioPermitidas),
      historia: data.historia === true,
      verTodosLosVendedores: data.verTodosLosVendedores === true,
      verTodosLosCanales: data.verTodosLosCanales === true,
      verTodasLasSucursales: data.verTodasLasSucursales === true,
      verTodosLosCentros: data.verTodosLosCentros === true,
      verTodosLosAlmacenes: data.verTodosLosAlmacenes === true,
    };
  }

  if (["VENDEDOR_PLANIFICADOR", "VENDEDOR_RETAIL", "VENDEDOR_MAYORISTA"].includes(rol)) {
    const vendedorCodigo = clean(data.vendedorCodigo);
    if (!vendedorCodigo) throw new Error("Debe informar el código de vendedor");

    return {
      ...base,
      vendedorCodigo,
      vendedoresPermitidos: [vendedorCodigo],
      canalesPermitidos:
        rol === "VENDEDOR_MAYORISTA"
          ? ["S4"]
          : rol === "VENDEDOR_RETAIL"
          ? ["S5"]
          : asArray(data.canalesPermitidos),
      sucursalesPermitidas: asArray(data.sucursalesPermitidas),
      centrosPermitidos: asArray(data.centrosPermitidos),
      almacenesPermitidos: asArray(data.almacenesPermitidos),
      organizacionesVentaPermitidas: asArray(
        data.organizacionesVentaPermitidas,
      ),
      sectoresPermitidos: asArray(data.sectoresPermitidos),
      listasPrecioPermitidas: asArray(data.listasPrecioPermitidas),
    };
  }

  throw new Error(`Perfil Planificador no reconocido: ${rol}`);
}

function mapUsuarioToSso(data) {
  const empresa = Number(data.empresa);
  if (!empresa) {
    throw new Error("No fue posible determinar la empresa SSO del usuario");
  }

  return {
    id: data.id || 0,
    nombre: clean(data.nombre),
    apellido: clean(data.apellido),
    usuario: clean(data.usuario),
    contrasena: clean(data.contrasena),
    empresa,
  };
}

function normalizeCreatedUserId(response) {
  if (typeof response === "number") return response;
  return (
    response?.id ||
    response?.usuario?.id ||
    response?.data?.id ||
    response?.resultado?.id ||
    null
  );
}

function parseJsonPerfil(value) {
  if (!value) return {};
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.error("JSON de perfil Planificador inválido:", error);
    return {};
  }
}

function normalizeSsoUser(user) {
  const alcance = parseJsonPerfil(user.json);
  const perfil = normalizePerfilSso(user.perfil);
  return {
    ...user,
    id: user.id,
    nombre: user.nombre || "",
    apellido: user.apellido || "",
    usuario: user.usuario || "",
    email: user.usuario || "",
    perfil: perfil.perfil,
    perfilDescripcion: perfil.perfilDescripcion,
    activo: user.activo === true,
    expirada: user.expirada === true,
    empresaId: alcance.empresaId ?? null,
    vendedorCodigo: alcance.vendedorCodigo || "",
    vendedoresPermitidos: alcance.vendedoresPermitidos || [],
    canalesPermitidos: alcance.canalesPermitidos || [],
    sucursalesPermitidas: alcance.sucursalesPermitidas || [],
    centrosPermitidos: alcance.centrosPermitidos || [],
    almacenesPermitidos: alcance.almacenesPermitidos || [],
    organizacionesVentaPermitidas: alcance.organizacionesVentaPermitidas || [],
    sectoresPermitidos: alcance.sectoresPermitidos || [],
    listasPrecioPermitidas: alcance.listasPrecioPermitidas || [],
    historia: alcance.historia === true,
    verTodosLosVendedores: alcance.verTodosLosVendedores === true,
    verTodosLosCanales: alcance.verTodosLosCanales === true,
    verTodasLasSucursales: alcance.verTodasLasSucursales === true,
    verTodosLosCentros: alcance.verTodosLosCentros === true,
    verTodosLosAlmacenes: alcance.verTodosLosAlmacenes === true,
  };
}

export const usuariosApi = {
  obtenerActual: async () => {
    const response = await ssoHttp.get("/user").then((r) => r.data);

    if (!response?.id) {
      throw new Error("SSO no devolvió el id del usuario autenticado");
    }

    return response;
  },

  listar: async (empresa = null, rut = null) => {
    const params = { aplicacion: getSsoAppName(empresa) };
    if (empresa) params.empresa = Number(empresa);
    if (rut) params.rut = rut;

    const response = await ssoHttp
      .get("/usuario/lista", { params })
      .then((r) => r.data);

    if (!response?.respuesta) {
      throw new Error(response?.mensaje || "No fue posible listar usuarios");
    }

    return (response.usuarios || []).map(normalizeSsoUser);
  },

  crear: async (data) => {
    const response = await ssoHttp
      .post("/usuario/agregar", mapUsuarioToSso(data))
      .then((r) => r.data);

    if (response?.respuesta === false) {
      throw new Error(response?.mensaje || "No fue posible crear el usuario");
    }

    const usuarioId = normalizeCreatedUserId(response);
    if (!usuarioId) {
      throw new Error(
        "SSO creó el usuario, pero no devolvió el id para asignar el perfil.",
      );
    }

    await usuariosApi.asignarPerfil(usuarioId, data.perfil, data);
    return response;
  },

  actualizarDatosPropios: async (id, data) => {
    const response = await ssoHttp
      .post("/usuario/editar", mapUsuarioToSso({ ...data, id }))
      .then((r) => r.data);

    if (response?.respuesta === false) {
      throw new Error(response?.mensaje || "No fue posible editar el usuario");
    }

    return response;
  },

  editarPerfil: async (id, data) => {
    if (!data.perfil) {
      throw new Error("Debe seleccionar un perfil para actualizar el usuario");
    }

    const perfilId = getPerfilId(data.perfil);
    if (!perfilId) {
      throw new Error(`Perfil no configurado para rol ${data.perfil}`);
    }

    const usuario = mapUsuarioToSso({ ...data, id });
    const response = await ssoHttp
      .post("/usuario/editarPerfil", {
        ...usuario,
        perfil: perfilId,
        json: buildJsonPerfil(data.perfil, data),
      })
      .then((r) => r.data);

    if (response?.respuesta === false) {
      throw new Error(
        response?.mensaje || "No fue posible editar el usuario y su perfil",
      );
    }

    return response;
  },

  actualizarCompleto: async (id, data) => usuariosApi.editarPerfil(id, data),

  // Compatibilidad temporal con consumidores anteriores.
  actualizar: async (id, data, asignarPerfil = true) =>
    asignarPerfil
      ? usuariosApi.actualizarCompleto(id, data)
      : usuariosApi.actualizarDatosPropios(id, data),

  eliminar: async (id) =>
    ssoHttp
      .post("/usuario/eliminar", null, { params: { id } })
      .then((r) => r.data),

  asignarPerfil: async (usuarioId, rol, data = {}) => {
    const perfilId = getPerfilId(rol);
    if (!perfilId) throw new Error(`Perfil no configurado para rol ${rol}`);

    const response = await ssoHttp
      .post("/usuario/perfil", {
        usuario: usuarioId,
        perfil: perfilId,
        json: buildJsonPerfil(rol, data),
      })
      .then((r) => r.data);

    if (response?.respuesta === false) {
      throw new Error(
        response?.mensaje || "No fue posible asignar el perfil al usuario",
      );
    }

    return response;
  },
};
